import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { ButtonClose } from '@design-system/button';
import { s__ } from '@design-system/i18n';
export const Remove = ({ onClick, title = '' }) => (_jsx(WrapperBtnClose, { children: _jsx(ButtonClose, { dataTestId: "ds-embed-close", onClick: onClick, screenReadersText: s__('Embed|Remove embed preview of %{title}.').i__({
            title,
        }), variant: "inversed" }) }));
const WrapperBtnClose = styled(Box) `
  position: absolute;
  right: ${({ theme }) => theme.space[3]}px;
  top: ${({ theme }) => theme.space[3]}px;
`;
//# sourceMappingURL=Remove.js.map